import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import MusicPreviewBtn, {
  MusicPreviewBtnDisable,
} from '../../../../components/music/MusicPreviewBtn';
import {IDemoStingerMessageProps} from '../../../../dto/demoStingerFulfilment.dto';
type Props = {
  adScript: IDemoStingerMessageProps[];
};
const DemoStingerAdScriptView = ({adScript}: Props) => {
  return (
    <Box>
      <Typography variant='h4'> AdScript</Typography>
      <TableContainer className='overflow-auto scrollbar h-full max-h-560 mb-2'>
        <Table
          sx={{
            '.MuiTableCell-root, .MuiTableRow-root': {
              padding: '6px 0',
            },
          }}>
          <TableHead>
            <TableRow>
              <TableCell className='text-white-50 w-500'>Name</TableCell>
              <TableCell className='text-white-50 w-800'>Script</TableCell>
              <TableCell className='text-white-50 w-100'>File</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {adScript.map(val => (
              <TableRow key={val.id}>
                <TableCell>{val.name}</TableCell>
                <TableCell>{val.message}</TableCell>
                <TableCell>
                  {val.file_url ? (
                    <MusicPreviewBtn
                      id={val.id}
                      url={val.file_url}
                      track_artist={val.message}
                      track_name={val.name}
                    />
                  ) : (
                    <MusicPreviewBtnDisable />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DemoStingerAdScriptView;
